// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3uv_k","tab":"ProcedureTabs_tab__1knkn"};